import { render, staticRenderFns } from "./collect-password.vue?vue&type=template&id=21b03bda"
import script from "./collect-password.vue?vue&type=script&lang=js"
export * from "./collect-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports